import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=53a8ec95"
import script from "./Drivers.vue?vue&type=script&lang=js"
export * from "./Drivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports